import { FlatList, VStack, View } from "@gluestack-ui/themed";
import { FinancialServiceItem, SelectFinancialServiceListProps } from "./types";
import { MustShow } from "@repo/core/components/core/MustShow";
import { ServicePointsListLoader } from "@repo/core/components/layout/SelectServicePointsList/loading";

import { FinancialServiceTile } from "./components/FinancialServiceTile";

export const SelectFinancialServiceList = ({
  financialServices,
  selectedFinancialService,
  onSelectFinancialService,
  isLoading
}: SelectFinancialServiceListProps) => {
  return (
    <VStack gap="$6">
      <MustShow isVisible={!isLoading} fallback={<ServicePointsListLoader />}>
        <VStack gap="$4">
          <FlatList
            data={financialServices}
            gap="$4"
            ItemSeparatorComponent={() => <View height="$3" />}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            keyExtractor={(item: any) => item.id.toString()}
            // Glustack not accept type of renderItem
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            renderItem={({ item: _item }: any) => {
              const item = _item as FinancialServiceItem;
              return (
                <FinancialServiceTile
                  id={item.id}
                  title={item.title}
                  isActive={Number(item.id) === selectedFinancialService}
                  onPress={() => onSelectFinancialService(Number(item.id))}
                />
              );
            }}
          />
        </VStack>
      </MustShow>
    </VStack>
  );
};
